<template>
  <div class="record-page">
    <!-- 顶部导航栏 -->
    <div class="top-header">
      <div class="nav-left">
        <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      </div>
      <div class="nav-title">积分榜单</div>
      <div class="nav-right">
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          class="home-link"
        >
          <van-icon name="wap-home" size="20" class="home-icon" />
        </a>
      </div>
    </div>

    <!-- 顶部标题栏 -->
    <div class="header">
      <div class="title-section">
        <div class="main-title">全球羽联盟积分榜单</div>
        <div class="subtitle">POINTS RANKING</div>
      </div>
    </div>

    <!-- 下拉刷新容器 -->
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
      :disabled="!isAtTop"
      success-text="刷新成功"
      pulling-text="下拉即可刷新..."
      loosing-text="释放即可刷新..."
      loading-text="加载中..."
      success-duration="1500"
      head-height="50"
    >
      <!-- 搜索框 -->
      <div class="search-container">
        <van-search
          v-model="searchKeyword"
          placeholder="搜索运动员姓名或编号"
          background="transparent"
          shape="round"
          show-action
          @search="onSearch"
          @clear="onSearchClear"
        >
          <template #left-icon>
            <van-icon name="search" color="#999" />
          </template>
          <template #action>
            <div class="search-action" @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>

      <!-- 筛选条件栏 -->
      <div class="filter-container">
        <div class="filter-item" @click="showGroupDrawer = true">
          <span class="filter-label">组别</span>
          <span class="filter-value">{{ selectedGroupName }}</span>
          <van-icon name="arrow-down" class="filter-icon" />
        </div>
      </div>

      <!-- 组别记录列表 -->
      <div class="group-records">
        <!-- 无搜索结果提示 -->
        <div
          v-if="rankedResultList.length === 0 && searchKeyword"
          class="no-result"
        >
          <van-icon name="search" size="48" color="#666" />
          <p>未找到"{{ searchKeyword }}"相关的运动员</p>
        </div>

        <!-- 空状态提示（无数据且无搜索词） -->
        <div
          v-if="
            rankedResultList.length === 0 &&
              !searchKeyword &&
              isShowEmpty === '1'
          "
          class="empty-state"
        >
          <div class="empty-icon">
            <van-icon name="records" size="64" color="#666" />
          </div>
          <div class="empty-text">暂无榜单数据</div>
          <div class="empty-hint">当前筛选条件下暂无运动员数据</div>
        </div>

        <!-- 榜单记录列表 -->
        <div
          :class="['ranking-card', getRankingClass(item.displayRank - 1)]"
          v-for="(item, index) in rankedResultList"
          :key="item.SFZH || index"
        >
          <!-- 排名标识 -->
          <div
            class="rank-badge"
            :class="getRankingClass(item.displayRank - 1)"
          >
            <div class="rank-number">{{ item.displayRank }}</div>
          </div>

          <!-- 运动员信息 -->
          <div class="player-info">
            <div class="player-avatar">
              <van-image
                class="avatar"
                round
                width="48px"
                height="48px"
                src="https://www.ptty.com.cn/wap/logo_b.png?v=20250530"
              />
              <div class="avatar-border" v-if="item.displayRank <= 3"></div>
            </div>
            <div class="player-details">
              <div class="player-name">{{ item.RYXM }}</div>
              <div class="player-meta-row">
                <div class="player-meta" v-if="item.XMJC">
                  <van-icon name="cluster-o" size="12" />
                  <span>{{ item.XMJC }}</span>
                </div>
                <div class="player-meta" v-if="item.UPTTM">
                  <van-icon name="clock-o" size="12" />
                  <span>{{ item.UPTTM }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 积分信息 -->
          <div class="points-section">
            <div class="points-value">
              {{
                bdlx === "ZFB"
                  ? item.JF
                  : bdlx === "SLV"
                  ? item.SLVNAME
                  : bdlx === "ZCS"
                  ? item.CSZCHANGSHU
                  : item.CSZCIS
              }}
            </div>
            <div class="points-label">
              {{
                bdlx === "ZFB"
                  ? "积分"
                  : bdlx === "SLV"
                  ? "胜率"
                  : bdlx === "ZCS"
                  ? "场数"
                  : "站数"
              }}
            </div>
          </div>

          <!-- 查看详情 -->
          <div class="detail-icon">
            <van-icon name="arrow" size="18" />
          </div>
        </div>

        <!-- 查看更多按钮 -->
        <div
          class="load-more-container"
          v-if="rankedResultList.length > 0 && !finished && !loading"
        >
          <van-button class="load-more-btn" @click="loadMore" block round>
            <van-icon name="arrow-down" />
            <span style="margin-left: 8px;">查看更多</span>
          </van-button>
        </div>

        <!-- 加载中提示 -->
        <div class="loading-tip" v-if="loading && rankedResultList.length > 0">
          <van-loading type="spinner" color="#ff4444" size="24px">
            正在加载更多数据...
          </van-loading>
        </div>

        <!-- 没有更多提示 -->
        <div class="no-more-tip" v-if="rankedResultList.length > 0 && finished">
          <van-divider>没有更多了</van-divider>
        </div>
      </div>
    </van-pull-refresh>

    <!-- 返回顶部悬浮按钮 -->
    <transition name="fade-scale">
      <div v-show="showBackTop" class="back-to-top-fab" @click="scrollToTop">
        <div class="fab-text">顶部</div>
      </div>
    </transition>

    <!-- 组别筛选抽屉 -->
    <van-popup
      v-model="showGroupDrawer"
      position="bottom"
      :style="{ height: '70%' }"
      round
      closeable
      close-icon="close"
    >
      <div class="drawer-container">
        <div class="drawer-header">
          <div class="drawer-title">选择组别</div>
        </div>

        <!-- 抽屉内搜索框 -->
        <div class="drawer-search">
          <van-search
            v-model="groupSearchKeyword"
            placeholder="搜索组别名称"
            background="transparent"
            shape="round"
          >
            <template #left-icon>
              <van-icon name="search" color="#999" />
            </template>
          </van-search>
        </div>

        <!-- 组别列表 -->
        <div class="drawer-content">
          <!-- 加载中状态 -->
          <div v-if="groupListLoading" class="group-loading">
            <van-loading type="spinner" color="#ff4444" size="32px">
              加载中...
            </van-loading>
          </div>

          <!-- 组别列表 -->
          <template v-else>
            <div
              v-for="group in filteredGroupList"
              :key="group.value"
              :class="['group-item', { active: selectedGroup === group.value }]"
              @click="selectGroup(group)"
            >
              <div class="group-name">{{ group.label }}</div>
              <van-icon
                v-if="selectedGroup === group.value"
                name="success"
                color="#ff4444"
                size="20"
              />
            </div>

            <!-- 无搜索结果 -->
            <div v-if="filteredGroupList.length === 0" class="no-group-result">
              <van-icon name="search" size="48" color="#999" />
              <p>未找到"{{ groupSearchKeyword }}"相关的组别</p>
            </div>
          </template>
        </div>
      </div>
    </van-popup>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";

export default {
  components: { LoadingCom },
  name: "MeNewIndex",

  data() {
    return {
      isShowEmpty: "1",
      refreshing: false,
      showBackTop: false,
      routeValue: "",
      phlx: "S",
      bdlx: "ZFB",
      openIdEn: "",
      op: "wapGL",
      resultList: [],
      searchKeyword: "",
      selectedGroup: "all",
      selectedProject: "all",
      selectedYear: "all",
      uis: "",
      isAtTop: true,
      // 分页参数
      pageNum: 1,
      pageSize: 20,
      loading: false,
      finished: false,
      totalCount: 0,
      // 组别筛选相关
      showGroupDrawer: false,
      groupSearchKeyword: "",
      groupList: [],
      groupListLoading: false
    };
  },

  computed: {
    // 计算带并列的排名列表
    rankedResultList() {
      const list = this.resultList;
      if (list.length === 0) return [];

      // 获取当前榜单类型的值字段
      const valueField =
        this.bdlx === "ZFB"
          ? "JF"
          : this.bdlx === "SLV"
          ? "SLV"
          : this.bdlx === "ZCS"
          ? "CSZCHANGSHU"
          : "CSZCIS";

      // 计算每个项目的排名
      let currentRank = 1;
      let previousValue = null;

      return list.map((item, index) => {
        const currentValue = item[valueField];

        if (index === 0) {
          // 第一名
          previousValue = currentValue;
          return { ...item, displayRank: 1 };
        }

        if (currentValue === previousValue) {
          // 值相同，并列排名
          return { ...item, displayRank: currentRank };
        } else {
          // 值不同，更新排名为当前索引+1
          currentRank = index + 1;
          previousValue = currentValue;
          return { ...item, displayRank: currentRank };
        }
      });
    },
    // 当前选中的组别名称
    selectedGroupName() {
      const group = this.groupList.find(g => g.value === this.selectedGroup);
      return group ? group.label : "全部组别";
    },
    // 过滤后的组别列表
    filteredGroupList() {
      if (!this.groupSearchKeyword || this.groupSearchKeyword.trim() === "") {
        return this.groupList;
      }
      const keyword = this.groupSearchKeyword.trim().toLowerCase();
      return this.groupList.filter(group => {
        return group.label.toLowerCase().includes(keyword);
      });
    }
  },

  created() {
    this.utilPost = this.$util.handler;
  },

  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    this.checkLogin();
    // 首次加载数据
    this.$nextTick(() => {
      this.mainData();
      this.loadGroupList();
    });
    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    // 移除滚动事件监听
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    // 处理滚动事件
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.showBackTop = scrollTop > 300;
      // 判断是否在顶部（允许10px的误差）
      this.isAtTop = scrollTop <= 10;
    },
    // 返回顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    // 下拉刷新处理
    onRefresh() {
      // 重置分页参数
      this.pageNum = 1;
      this.finished = false;
      this.resultList = [];
      // 重新加载当前榜单数据
      this.mainData();
    },
    // 查看更多按钮点击处理
    loadMore() {
      if (this.loading || this.finished) {
        return;
      }

      this.loading = true;
      this.pageNum++;

      // 立即显示加载状态，避免延迟感
      this.$nextTick(() => {
        this.mainData(true);
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    goToPlayerDetail(item) {
      var busData = {
        SFZHEN: item.SFZH
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getPlayerInfo" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost
        .sendPost()
        .then(data => {
          if (!data.isSuccess) {
            alert(data.msg);
            this.refreshing = false;
            return;
          }
          if (data.content.ISZY) {
            if (data.content.ISZY === "Y") {
              this.$router.push({
                path: "/meQygjIndex",
                query: {
                  sfzh: item.SFZH
                }
              });
            } else {
              this.$toast("该球员未开启生涯数据查看权限");
            }
          } else {
            this.$toast("该球员未开启生涯数据查看权限");
          }
        })
        .catch(error => {
          console.error("加载数据失败:", error);
          this.refreshing = false;
        });
    },

    checkLogin() {
      var openIdEn = localStorage.getItem("openIdEn");
      if (
        openIdEn === undefined ||
        openIdEn === null ||
        openIdEn.length === 0
      ) {
        var that = this;
        this.utilPost.getOpenId(function(openId) {
          var ryInfoLocal = localStorage.getItem("ryInfo");
          if (
            ryInfoLocal === undefined ||
            ryInfoLocal === "" ||
            ryInfoLocal === null ||
            ryInfoLocal.length === 0
          ) {
            that.$router.push({ path: "/loginIndex" });
            return;
          } else {
            this.uis = ryInfoLocal;
          }
        });
      } else {
        var ryInfoLocal = localStorage.getItem("ryInfo");
        if (
          ryInfoLocal === undefined ||
          ryInfoLocal === "" ||
          ryInfoLocal === null ||
          ryInfoLocal.length === 0
        ) {
          this.$router.push({ path: "/loginIndex" });
        } else {
          this.uis = ryInfoLocal;
        }
      }
      this.openIdEn = openIdEn;
    },
    mainData(isLoadMore = false) {
      var busData = {
        phlx: this.phlx,
        bdlx: this.bdlx,
        group: this.selectedGroup === "all" ? "" : this.selectedGroup,
        project: this.selectedProject,
        year: this.selectedYear,
        TELEN: this.uis.TELEN,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        searchKeyword: this.searchKeyword.trim()
      };

      if (!isLoadMore) {
        this.resultList = [];
      }
      this.isShowEmpty = "0";

      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "qqYlmSyBang" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      //alert(JSON.stringify(paramData));
      this.utilPost
        .sendPost()
        .then(data => {
          // 调试：查看返回的数据结构
          if (data.content && data.content.length > 0) {
            console.log("第一条数据:", data.content[0]);
          }

          this.isShowEmpty = "1";

          if (!data.isSuccess) {
            alert(data.msg);
            this.loading = false;
            this.refreshing = false;
            return;
          }

          // 处理分页数据 - 使用 requestAnimationFrame 优化渲染
          requestAnimationFrame(() => {
            if (isLoadMore) {
              // 追加数据
              this.resultList = this.resultList.concat(data.content || []);
            } else {
              // 首次加载或刷新
              this.resultList = data.content || [];
            }

            // 判断是否还有更多数据
            if (data.totalNums) {
              this.totalCount = data.totalNums;
              this.finished = this.resultList.length >= this.totalCount;
            } else {
              // 如果没有返回总数，根据返回数据量判断
              this.finished =
                !data.content || data.content.length < this.pageSize;
            }

            this.$nextTick(() => {
              this.loading = false;
              this.refreshing = false;
            });
          });
        })
        .catch(error => {
          console.error("加载数据失败:", error);
          this.loading = false;
          this.refreshing = false;
        });
    },
    getRankingClass(index) {
      // 根据排名返回不同的CSS类
      switch (index) {
        case 0: // 第1名 - 金色
          return "gold";
        case 1: // 第2名 - 银色
          return "silver";
        case 2: // 第3名 - 铜色
          return "bronze";
        default:
          return "normal";
      }
    },
    onSearchClear() {
      this.searchKeyword = "";
      // 清空搜索时重新加载数据
      this.pageNum = 1;
      this.finished = false;
      this.resultList = [];
      this.mainData();
    },
    // 搜索按钮点击
    onSearch() {
      // 重置分页并重新加载数据
      this.pageNum = 1;
      this.finished = false;
      this.resultList = [];
      this.mainData();
    },
    // 加载组别列表
    loadGroupList() {
      this.groupListLoading = true;

      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op,
          methodName: "getXmZbList"
        },
        busData: {}
      };

      this.utilPost.paramData = paramData;
      this.utilPost
        .sendPost()
        .then(data => {
          this.groupListLoading = false;

          if (!data.isSuccess) {
            this.$toast(data.msg || "加载组别列表失败");
            // 失败时使用默认数据
            this.groupList = [{ value: "all", label: "全部组别" }];
            return;
          }

          // 处理返回的组别数据
          const groups = [{ value: "all", label: "全部组别" }];

          if (data.content && Array.isArray(data.content)) {
            data.content.forEach(item => {
              if (item.XMJC) {
                groups.push({
                  value: item.XMJC,
                  label: item.XMJC
                });
              }
            });
          }

          this.groupList = groups;
        })
        .catch(error => {
          console.error("加载组别列表失败:", error);
          this.groupListLoading = false;
          this.$toast("加载组别列表失败");
          // 失败时使用默认数据
          this.groupList = [{ value: "all", label: "全部组别" }];
        });
    },
    // 选择组别
    selectGroup(group) {
      this.selectedGroup = group.value;
      this.showGroupDrawer = false;
      this.groupSearchKeyword = "";

      // 重置分页并重新加载数据
      this.pageNum = 1;
      this.finished = false;
      this.resultList = [];
      this.mainData();
    }
  }
};
</script>

<style scoped>
/* 防止横向滚动 - 全局设置 */
* {
  box-sizing: border-box;
}

/* 整体页面样式 */
.record-page {
  min-height: 100vh;
  background: #2a2a2a;
  color: white;
  padding-bottom: 80px;
  overflow-x: hidden;
  max-width: 100vw;
  position: relative;
}

/* 顶部导航栏 */
.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #1a1a1a;
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  border-bottom: 1px solid #333;
}

.nav-left {
  width: 60px;
  display: flex;
  justify-content: flex-start;
}

.back-icon {
  font-size: 24px;
  color: #fff;
}

.nav-title {
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}

.nav-right {
  width: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

.home-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.home-icon {
  color: #fff;
  transition: all 0.3s ease;
}

.home-icon:hover {
  transform: scale(1.1);
  color: #ff4444;
}

/* 榜单记录列表 */
.group-records {
  padding: 16px;
  background: transparent;
}

/* 榜单卡片 */
.ranking-card {
  background: linear-gradient(135deg, #333 0%, #3a3a3a 100%);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  margin-bottom: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #444;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* 玻璃光泽动画 */
.ranking-card::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -100%;
  width: 50%;
  height: 200%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.05),
    transparent
  );
  transform: skewX(-25deg);
  animation: glassShine 3s ease-in-out infinite;
}

@keyframes glassShine {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 150%;
  }
}

.ranking-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #ff4444 0%, #cc3333 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ranking-card:active {
  transform: scale(0.98);
}

.ranking-card:hover {
  background: linear-gradient(135deg, #3a3a3a 0%, #444 100%);
  border-color: #ff4444;
  box-shadow: 0 4px 16px rgba(255, 68, 68, 0.3);
  transform: translateY(-2px);
}

.ranking-card:hover::before {
  opacity: 1;
}

/* 排名标识 */
.rank-badge {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
  border: 2px solid #444;
  position: relative;
  transition: all 0.3s ease;
}

.rank-number {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}

/* 第一名 - 金色 */
.rank-badge.gold {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  border-color: #ffd700;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.4);
}

.rank-badge.gold .rank-number {
  color: #8b5a00;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
}

/* 第二名 - 银色 */
.rank-badge.silver {
  background: linear-gradient(135deg, #c0c0c0 0%, #e5e5e5 100%);
  border-color: #c0c0c0;
  box-shadow: 0 0 12px rgba(192, 192, 192, 0.4);
}

.rank-badge.silver .rank-number {
  color: #4a4a4a;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
}

/* 第三名 - 铜色 */
.rank-badge.bronze {
  background: linear-gradient(135deg, #cd7f32 0%, #d4a574 100%);
  border-color: #cd7f32;
  box-shadow: 0 0 12px rgba(205, 127, 50, 0.4);
}

.rank-badge.bronze .rank-number {
  color: #4a2a0a;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.3);
}

/* 无结果提示 */
.no-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.no-result p {
  margin-top: 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

/* 空状态提示 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  min-height: 400px;
}

.empty-icon {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.empty-hint {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
}

/* 运动员信息 */
.player-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.player-avatar {
  position: relative;
  flex-shrink: 0;
}

.avatar-border {
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  border-radius: 50%;
  border: 2px solid;
  animation: avatarGlow 2s ease-in-out infinite;
}

.player-details {
  flex: 1;
  min-width: 0;
}

.player-name {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.player-meta-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.player-meta {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.player-meta .van-icon {
  color: rgba(255, 255, 255, 0.5);
}

/* 积分信息 */
.points-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  flex-shrink: 0;
}

.points-value {
  font-size: 24px;
  font-weight: 700;
  color: #ffd700;
  line-height: 1;
  text-shadow: 0 2px 4px rgba(255, 215, 0, 0.3);
}

.points-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

/* 查看详情图标 */
.detail-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 68, 68, 0.15);
  color: #ff4444;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.ranking-card:hover .detail-icon {
  background: rgba(255, 68, 68, 0.25);
  transform: translateX(4px);
}

/* 前三名特殊样式 */
.ranking-card.gold {
  background: linear-gradient(
    135deg,
    rgba(255, 215, 0, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-color: rgba(255, 215, 0, 0.5);
  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.2);
}

.ranking-card.gold .rank-badge {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.ranking-card.gold .avatar-border {
  border-color: #ffd700;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.6);
}

.ranking-card.gold .points-value {
  color: #ffd700;
  text-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
}

.ranking-card.silver {
  background: linear-gradient(
    135deg,
    rgba(192, 192, 192, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-color: rgba(192, 192, 192, 0.5);
  box-shadow: 0 4px 20px rgba(192, 192, 192, 0.2);
}

.ranking-card.silver .rank-badge {
  background: linear-gradient(135deg, #c0c0c0 0%, #e5e5e5 100%);
  box-shadow: 0 4px 12px rgba(192, 192, 192, 0.4);
}

.ranking-card.silver .avatar-border {
  border-color: #c0c0c0;
  box-shadow: 0 0 12px rgba(192, 192, 192, 0.6);
}

.ranking-card.silver .points-value {
  color: #e5e5e5;
  text-shadow: 0 2px 8px rgba(192, 192, 192, 0.4);
}

.ranking-card.bronze {
  background: linear-gradient(
    135deg,
    rgba(205, 127, 50, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  border-color: rgba(205, 127, 50, 0.5);
  box-shadow: 0 4px 20px rgba(205, 127, 50, 0.2);
}

.ranking-card.bronze .rank-badge {
  background: linear-gradient(135deg, #cd7f32 0%, #d4a574 100%);
  box-shadow: 0 4px 12px rgba(205, 127, 50, 0.4);
}

.ranking-card.bronze .avatar-border {
  border-color: #cd7f32;
  box-shadow: 0 0 12px rgba(205, 127, 50, 0.6);
}

.ranking-card.bronze .points-value {
  color: #d4a574;
  text-shadow: 0 2px 8px rgba(205, 127, 50, 0.4);
}

@keyframes avatarGlow {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
}

/* 顶部标题栏 */
.header {
  padding: 32px 20px 24px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #333;
}

.header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(255, 68, 68, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(255, 68, 68, 0.08) 0%,
      transparent 50%
    );
  opacity: 0.6;
}

.title-section {
  position: relative;
  z-index: 1;
  text-align: center;
}

.main-title {
  font-size: 28px;
  font-weight: 700;
  color: #ff4444;
  margin-bottom: 8px;
  letter-spacing: 2px;
  text-shadow: 0 2px 4px rgba(255, 68, 68, 0.3);
}

.subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 3px;
  font-weight: 500;
}

/* 搜索框容器 */
.search-container {
  background: #2a2a2a;
  backdrop-filter: blur(10px);
  padding: 16px 16px 8px 16px;
  border-bottom: 1px solid #333;
}

.search-container .van-search {
  padding: 0;
}

.search-container .van-search__content {
  background: linear-gradient(135deg, #333 0%, #3a3a3a 100%);
  border: 1px solid #444;
  transition: all 0.3s ease;
}

.search-container .van-search__content:focus-within {
  border-color: #ff4444;
  background: #3a3a3a;
  box-shadow: 0 0 0 3px rgba(255, 68, 68, 0.15);
}

.search-container .van-field__control {
  color: #fff;
  font-size: 14px;
}

.search-container .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.search-container .van-icon {
  color: rgba(255, 255, 255, 0.6);
}

.search-action {
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  color: #ff4444;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.search-action:active {
  opacity: 0.7;
  transform: scale(0.95);
}

/* 筛选条件栏 */
.filter-container {
  background: #2a2a2a;
  padding: 8px 16px 16px 16px;
  display: flex;
  gap: 12px;
  border-bottom: 1px solid #333;
}

.filter-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: linear-gradient(135deg, #333 0%, #3a3a3a 100%);
  border: 1px solid #444;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-item:active {
  transform: scale(0.98);
  background: #3a3a3a;
}

.filter-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 8px;
}

.filter-value {
  flex: 1;
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  text-align: left;
}

.filter-icon {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  transition: transform 0.3s ease;
}

/* 无结果提示 */
.no-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.no-result p {
  margin-top: 16px;
  font-size: 14px;
  color: #999;
}

/* 空状态提示 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  min-height: 400px;
}

.empty-icon {
  margin-bottom: 20px;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.empty-text {
  font-size: 16px;
  font-weight: 600;
  color: #999;
  margin-bottom: 8px;
}

.empty-hint {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

/* 会员推广横幅 */
.vip-promotion-banner {
  margin: 16px 16px 20px 16px;
  cursor: pointer;
  animation: slideInDown 0.6s ease-out;
}

.vip-banner-bg {
  position: relative;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.4),
    0 4px 12px rgba(118, 75, 162, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.vip-banner-bg::before {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  animation: vipRotate 8s linear infinite;
}

.vip-promotion-banner:hover .vip-banner-bg {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(102, 126, 234, 0.5),
    0 6px 16px rgba(118, 75, 162, 0.4);
}

.vip-promotion-banner:active .vip-banner-bg {
  transform: translateY(-2px) scale(1.01);
}

.vip-banner-content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
  z-index: 1;
}

.vip-icon-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.vip-icon {
  color: #fff;
  animation: vipIconPulse 2s ease-in-out infinite;
}

.vip-sparkle {
  position: absolute;
  top: -4px;
  right: -4px;
  font-size: 20px;
  animation: vipSparkle 1.5s ease-in-out infinite;
}

.vip-text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.vip-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.vip-highlight {
  background: linear-gradient(90deg, #fff 0%, #ffe5ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: vipTextShine 3s ease-in-out infinite;
}

.vip-separator {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.vip-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.vip-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  color: #fff;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.vip-promotion-banner:hover .vip-arrow {
  transform: translateX(4px);
  background: rgba(255, 255, 255, 0.3);
}

.vip-banner-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: vipShine 3s ease-in-out infinite;
}

/* 会员横幅动画 */
@keyframes slideInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes vipRotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes vipIconPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

@keyframes vipSparkle {
  0%,
  100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.2) rotate(180deg);
  }
}

@keyframes vipTextShine {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes vipShine {
  0% {
    left: -100%;
  }
  50%,
  100% {
    left: 100%;
  }
}

/* 卡片进入动画 - 已禁用以提升性能 */
/* 如需启用动画，取消注释以下代码并在模板中添加 card-enter 类
@keyframes slideInUp {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-enter {
  animation: slideInUp 0.25s ease-out forwards;
  animation-fill-mode: both;
  opacity: 0;
}
*/

/* 响应式动画优化 */
@media (prefers-reduced-motion: reduce) {
  .card-enter {
    animation: none !important;
  }
}

/* 移动端优化 */
@media (max-width: 768px) {
  .card-enter {
    animation-duration: 0.2s;
  }
}

/* 底部导航栏 */
.bottom-nav {
  background: rgba(15, 32, 39, 0.95) !important;
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
}

.bottom-nav .van-tabbar-item {
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
}

.bottom-nav .van-tabbar-item--active {
  color: #4a90e2;
  font-weight: 600;
}

/deep/ .van-field__control {
  color: #fff;
}

/* 返回顶部悬浮按钮 */
.back-to-top-fab {
  position: fixed;
  bottom: 30px;
  right: 20px;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(255, 68, 68, 0.4);
  cursor: pointer;
  z-index: 9999;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.2);
}

.back-to-top-fab:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 20px rgba(255, 68, 68, 0.6);
}

.back-to-top-fab:active {
  transform: translateY(-2px) scale(0.95);
}

.fab-text {
  font-size: 12px;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 淡入缩放过渡动画 */
.fade-scale-enter-active {
  animation: fadeScaleIn 0.3s ease-out;
}

.fade-scale-leave-active {
  animation: fadeScaleOut 0.2s ease-in;
}

@keyframes fadeScaleIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes fadeScaleOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.5);
  }
}

/* 查看更多按钮容器 */
.load-more-container {
  padding: 20px 16px;
  display: flex;
  justify-content: center;
}

.load-more-btn {
  background: linear-gradient(135deg, #ff4444 0%, #cc3333 100%);
  border: none;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  height: 44px;
  box-shadow: 0 4px 12px rgba(255, 68, 68, 0.3);
  transition: all 0.3s ease;
}

.load-more-btn:active {
  transform: scale(0.98);
  box-shadow: 0 2px 8px rgba(255, 68, 68, 0.4);
}

.load-more-btn:disabled {
  opacity: 0.6;
}

.load-more-btn /deep/ .van-button__text {
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.load-more-btn /deep/ .van-loading__spinner {
  color: #fff;
}

.load-more-btn /deep/ .van-icon {
  color: #fff;
}

/* 加载中提示 */
.loading-tip {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-tip /deep/ .van-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.loading-tip /deep/ .van-loading__text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  margin-top: 8px;
}

/* 没有更多提示 */
.no-more-tip {
  padding: 20px 16px;
  text-align: center;
}

.no-more-tip /deep/ .van-divider {
  color: rgba(255, 255, 255, 0.5);
  border-color: #444;
  font-size: 13px;
}

/* 抽屉容器样式 */
.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #2a2a2a;
}

.drawer-header {
  padding: 20px 16px 16px;
  border-bottom: 1px solid #333;
  background: #1a1a1a;
}

.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.drawer-search {
  padding: 16px;
  background: #2a2a2a;
  border-bottom: 1px solid #333;
}

.drawer-search .van-search {
  padding: 0;
}

.drawer-search .van-search__content {
  background: linear-gradient(135deg, #333 0%, #3a3a3a 100%);
  border: 1px solid #444;
}

.drawer-search .van-field__control {
  color: #fff;
}

.drawer-search .van-field__control::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.group-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.group-loading /deep/ .van-loading__text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-top: 12px;
}

.group-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #2a2a2a;
  border-bottom: 1px solid #333;
  cursor: pointer;
  transition: all 0.3s ease;
}

.group-item:active {
  background: #333;
}

.group-item.active {
  background: rgba(255, 68, 68, 0.1);
  border-left: 3px solid #ff4444;
}

.group-name {
  font-size: 15px;
  color: #fff;
  font-weight: 500;
}

.group-item.active .group-name {
  color: #ff4444;
}

.no-group-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.no-group-result p {
  margin-top: 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

/* 自定义 van-popup 样式 */
/deep/ .van-popup {
  background: #2a2a2a;
}

/deep/ .van-popup__close-icon {
  color: rgba(255, 255, 255, 0.8);
  font-size: 20px;
}

/deep/ .van-popup__close-icon:active {
  color: #ff4444;
}
</style>

<style scoped>
/* 组件内样式 - 只影响 MeNewIndex 组件 */
/* 通过 scoped 确保样式不会泄漏到其他组件 */
</style>



// WEBPACK FOOTER //
// src/components/MeIndex/QqYlmJfIndex.vue